import React, { useState } from 'react'
import { Download } from 'lucide-react'
import RangePicker from './RangePicker'
import { headerSubtitle, rangeLabel } from './model'

export default function WorkspaceHeader({ workspace, range, resolvedRange, onRangeChange, onExport }) {
  const [exporting, setExporting] = useState(false)

  const handleExport = async () => {
    if (exporting) return
    setExporting(true)
    try { await onExport() } finally { setExporting(false) }
  }

  return (
    <section id="pw-overview" className="pw-header" aria-label="Overview">
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 1.2, color: 'var(--text-muted)' }}>
          PARTNER WORKSPACE
        </div>
        <h1 className="pw-title" style={{ fontSize: 28, fontWeight: 800, letterSpacing: -0.5, marginTop: 4 }}>
          Overview
        </h1>
        <p style={{ margin: '4px 0 0', fontSize: 13, color: 'var(--text-secondary)' }}>
          {headerSubtitle(workspace)}
        </p>
      </div>

      <div className="pw-header-actions">
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, alignItems: 'flex-start' }}>
          <RangePicker value={range} onChange={onRangeChange} />
          {resolvedRange && (
            <span className="pw-num" style={{ fontSize: 12, color: 'var(--text-muted)' }}>
              {rangeLabel(resolvedRange)}
            </span>
          )}
        </div>
        <button
          type="button"
          onClick={handleExport}
          disabled={exporting}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 8, padding: '9px 14px',
            borderRadius: 10, border: 0, cursor: exporting ? 'wait' : 'pointer',
            background: 'var(--kpi-hero-bg)', color: 'var(--kpi-hero-fg)',
            fontSize: 13, fontWeight: 600, opacity: exporting ? 0.7 : 1,
          }}
        >
          <Download size={14} aria-hidden="true" />
          {exporting ? 'Exporting…' : 'Export CSV'}
        </button>
      </div>
    </section>
  )
}
